export default "__VITE_ASSET__DkM3$tFp__"